<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="600px" persistent>
  <v-card>
    <v-card-title>
      <v-icon left color="primary">mdi-account</v-icon>
      Customer Details
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="selectedClient">
      <div class="mb-2">
        <strong>Name :</strong> {{ selectedClient.client_username }}
      </div>
      <div class="mb-2">
        <strong>Transactions :</strong>
        <v-list dense>
          <v-list-item
            v-for="tx in selectedClient.transactions"
            :key="tx.id"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ formatDate(tx.date) }} - {{ formatCurrency(tx.amount) }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon :color="statusColor(tx.status)">
                mdi-check-circle
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
        <v-alert
          v-if="selectedClient.transactions.length === 0"
          type="info"
          dense
          class="mt-2"
        >
        No transactions found
        </v-alert>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="dialog = false">Fermer</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Filtres Date -->
    <v-row>
      <v-col cols="12" md="3">
        <v-menu v-model="startMenu" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate"
              label="Date de début"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate" @input="startMenu = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3">
        <v-menu v-model="endMenu" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              label="Date de fin"
              prepend-icon="mdi-calendar"
              readonly
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate" @input="endMenu = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2">
        <v-btn @click="resetDates" color="error" block>
          <v-icon left>mdi-filter-remove</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-row>

    <!-- Section Comptes Business -->
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-4">
          <v-card-title class="white--text" style="background-color: #ffffff; color: #2c3e50 !important;">
            <v-icon left color="primary">mdi-office-building</v-icon>
            Professional Accounts ({{ metadata.count }})
            <v-spacer></v-spacer>
            <v-chip label color="primary" dark>
              Total Balance: {{ formatCurrency(total_balance) }}
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="businessHeaders"
              :items="businessProfiles"
              :search="businessSearch"
              :items-per-page="10"
            >
              <template #[`item.payment_status`]="{ item }">
                <v-chip :color="item.payment_status ? 'success' : 'error'" small>
                  {{ item.payment_status ? 'Actif' : 'Inactif' }}
                </v-chip>
              </template>

              <template #[`item.balance`]="{ item }">
                <span class="font-weight-bold">
                  {{ formatCurrency(item.balance) }}
                </span>
              </template>

              <template #[`item.created_at`]="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template #[`item.id_user`]="{ item }">
                <i class="fa-solid fa-comments" @click="goToChat(item.id_user)"></i>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Section Parrainage Modifiée -->
    
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      businessSearch: '',
      serialSearch: '',
      startDate: null,
      endDate: null,
      startMenu: false,
      dialog: false,
      selectedClient: null,
      endMenu: false,
      total_balance: 0,
      metadata: {},
      businessProfiles: [],
      serialProfiles: [],
      
      businessHeaders: [
        { text: 'Utilisateur', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Statut Paiement', value: 'payment_status', align: 'center' },
        { text: 'Solde', value: 'balance', align: 'end' },
        { text: 'Date Création', value: 'created_at', align: 'center' },
        { text: 'Chat',value: 'id_user'},
      ],

      serialHeaders: [
        { text: 'Parrain', value: 'referrer', width: '25%' },
        { text: 'Statistiques', value: 'stats', width: '30%' },
        { text: 'Détails Clients', value: 'clients' }
      ]
    }
  },

  computed: {
    groupedSerialProfiles() {
  const grouped = new Map()

  this.serialProfiles.forEach(profile => {
    // Utiliser directement referrer_username comme clé
    const key = profile.referrer_username || 'sans-parrain'

    const existing = grouped.get(key) || {
      referrer: key !== 'sans-parrain' ? {
        name: profile.referrer_username,
        initials: profile.referrer_username.slice(0, 2).toUpperCase(),
        firstActivity: profile.created_at
      } : null,
      stats: { clients: 0, commissions: 0 },
      clients: []
    }

    existing.stats.clients += profile.clients.length
    existing.stats.commissions += profile.total_commissions
    existing.clients.push(...profile.clients)

    grouped.set(key, existing)
  })

  return Array.from(grouped.values()).sort((a, b) => 
    b.stats.commissions - a.stats.commissions
  )
}
  },

  watch: {
    startDate() {
      this.fetchData()
    },
    endDate() {
      this.fetchData()
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      try {
        const params = { 
          start_date: this.startDate, 
          end_date: this.endDate 
        }
        
        const response = await axios.get('/api/v1/manager/business-accounts/', { params })
        
        this.businessProfiles = response.data.business_profiles
        this.serialProfiles = response.data.serial_profiles
        this.total_balance = response.data.total_balance || 0
        this.metadata = response.data.metadata || {}

      } catch (error) {
        this.showError('Erreur lors du chargement des données')
        console.error('API Error:', error.response?.data || error.message)
      }
    },
    openClientDialog(clients) {
    this.selectedClient = clients[0]
    this.dialog = true
  },
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      const options = { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
      return new Date(dateString).toLocaleDateString('fr-FR', options)
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('fr-FR', { 
        style: 'currency', 
        currency: 'XAF',
        minimumFractionDigits: 0
      }).format(value)
    },

    statusColor(status) {
      return {
        'COMPLETED': 'success',
        'PENDING': 'warning',
        'CANCELLED': 'error'
      }[status] || 'grey'
    },

    paymentMethodIcon(method) {
      return {
        'MTN': 'mdi-cellphone',
        'OM': 'mdi-orange'
      }[method] || 'mdi-wallet'
    },

    paymentMethodColor(method) {
      return {
        'MTN': 'yellow-darken-3',
        'OM': 'orange-darken-2'
      }[method] || 'grey'
    },

    resetDates() {
      this.startDate = null
      this.endDate = null
    },

    showError(message) {
      this.$store.commit('setSnackBarMessage', message)
      this.$store.commit('setSnackBarColor', 'error')
      this.$store.commit('activateSnackBar', true)
    },
    goToChat(userId) {
    this.$router.push({ name: 'chat.chat:id', params: { id: userId } });
  },
  }
}
</script>

<style scoped>
.v-expansion-panel-header__icon {
  display: none !important;
}

.v-expansion-panel-content__wrap {
  padding: 0 16px 16px !important;
}

.v-list-item {
  min-height: 48px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.v-avatar {
  flex-shrink: 0;
}

.caption {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}
.v-card-title {
  border-bottom: 2px solid #eeeeee;
  padding: 16px 24px;
}

.v-chip--clickable {
  cursor: pointer;
}

.v-dialog {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}
</style>